import { css } from '@emotion/core';
import { typographyStyles, constants } from '@newsela/angelou';

const { textS } = typographyStyles;
const { colors } = constants;

export const $cardBody = (expanded, isReviewing) => css`
  overflow: ${expanded && 'auto'};
  transition: max-height 0.4s ease;
  max-height: ${!expanded ? '50px' : '250px'};
  scroll-behavior: auto;
  overflow: auto;

  span:nth-of-type(1) {
      font-weight: 700;
  }

  span:nth-of-type(2) {  
      ${textS};
      color: ${colors.ui.neutral[500]};
  }
`;

export const $toggleButton = css`
  cursor: pointer;
  margin-left: 4px;
  color: ${colors.ui.core[400]};
`;
